// extracted by mini-css-extract-plugin
export var brand = "_9d-9";
export var compact = "_9d-6";
export var extraSmall = "_9d-7";
export var icon = "_9d-0";
export var large = "_9d-4";
export var light = "_9d-1";
export var medium = "_9d-5";
export var outline = "_9d-b";
export var primaryDark = "_9d-a";
export var primaryLight = "_9d-8";
export var primaryModern = "_9d-c";
export var success = "_9d-2";
export var successSolid = "_9d-3";